module.exports = __webpack_public_path__ + "img/aboutPage_service_icon88.292f8999.png";